﻿const Cookies = require("js-cookie");
const { getDebugMode, getDomain, getEnvironment } = require("../helpers/methods");

window.mycookie = Cookies;

const COOKIE_NAME = "token";
const COOKIE_NAME_2 = "auth:token";
const COOKIE_DOMAIN = window.location.hostname.includes("localhost") ? "localhost" : `.${getDomain().split(".").slice(-2).join(".")}`;

if (getDebugMode()) {
	console.log("COOKIE_DOMAIN", COOKIE_DOMAIN);
}

const setToken = token => {
	try {
		if (getDebugMode()) {
			console.log("setToken", token);
		}

		if (typeof token !== "string") {
			console.log("The token need to be a string");
			throw new Error("The token need to be a string.");
		}

		Cookies.set(COOKIE_NAME, token, {
			domain: COOKIE_DOMAIN,
			expires: 1
			// secure: window.location.hostname !== "localhost"
		});

		Cookies.set(COOKIE_NAME_2, token, {
			domain: COOKIE_DOMAIN,
			expires: 1
		});

		window.token = token;
	} catch (error) {
		console.log("[authentication.js][setToken]", error);

		throw new Error(error);
	}
};

const getToken = () => {
	try {
		if (getDebugMode()) {
			console.log("getToken");
		}

		if (window.token) {
			return window.token;
		}

		return Cookies.get(COOKIE_NAME, {
			domain: COOKIE_DOMAIN
		});
	} catch (error) {
		console.log("[authentication.js][getToken]", error);

		throw new Error(error);
	}
};

const removeToken = () => {
	try {
		if (getDebugMode()) {
			console.log("removeToken");
		}

		Cookies.remove(COOKIE_NAME, {
			domain: COOKIE_DOMAIN
		});
		Cookies.remove(COOKIE_NAME_2, {
			domain: COOKIE_DOMAIN
		});

		window.token = undefined;
	} catch (error) {
		console.log("[authentication.js][removeToken]", error);

		throw new Error(error);
	}
};

const isTokenExpired = token => {
	try {
		if (getDebugMode()) {
			console.log("isTokenExpired", token);
		}

		const base64Url = token.split(".")[1];
		const base64Content = base64Url.replace(/-/g, "+").replace(/_/g, "/");
		const payload = JSON.parse(atob(base64Content));

		if (payload && payload.exp > Math.round(Date.now() / 1000)) {
			return false;
		}

		return true;
	} catch (error) {
		return true;
	}
};

module.exports = { setToken, getToken, removeToken, isTokenExpired };
